module.exports = __webpack_public_path__ + "img/logo.69eb0a23.png";